import React, { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CinematicIntro } from "@/components/CinematicIntro";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { FoundersStory } from "@/components/FoundersStory";
import { FourMore } from "@/components/FourMore";
import { Blog } from "@/components/Blog";
import { Shop } from "@/components/Shop";
import { LiteraryWorks } from "@/components/LiteraryWorks";
import { Comics } from "@/components/Comics";
import { Music } from "@/components/Music";
import { FourPillars } from "@/components/FourPillars";
import { NFTGallery } from "@/components/NFTGallery";
import { MusicLicensing } from "@/components/MusicLicensing";
import { MindesignRadio } from "@/components/MindesignRadio";
import { AmpedUpLife } from "@/components/AmpedUpLife";
import { AfterDarkPortal } from "@/components/AfterDarkPortal";
import { GiveMore } from "@/components/GiveMore";
import { ProudPartners } from "@/components/ProudPartners";
import { Contact } from "@/components/Contact";
import { NewsletterSignup } from "@/components/NewsletterSignup";
import { Footer } from "@/components/Footer";
import { AdminPanel } from "@/components/AdminPanel";
import { RadioProvider } from "@/context/RadioContext";
import { FloatingRadio } from "@/components/FloatingRadio";
import { SpunFunReturnListener } from "@/components/SpunFunReturnListener";
import { NowPlayingToast } from "@/components/NowPlayingToast";
import { initAnalytics } from "@/lib/analytics";

const Home = () => {
  const [showIntro, setShowIntro] = useState(true);

  useEffect(() => {
    // Check if user has seen intro in this session
    const introSeen = sessionStorage.getItem('mindesign_intro_seen');
    if (introSeen) {
      setShowIntro(false);
    }
  }, []);

  const handleIntroComplete = () => {
    sessionStorage.setItem('mindesign_intro_seen', 'true');
    setShowIntro(false);
  };

  return (
    <>
      {showIntro && <CinematicIntro onComplete={handleIntroComplete} />}
      <div className={`min-h-screen bg-gunmetal-950 ${showIntro ? 'hidden' : 'block'}`}>
        <Navbar />
        <Hero />
        <About />
        <FoundersStory />
        <FourMore />
        <Blog />
        <Shop />
        <LiteraryWorks />
        <Comics />
        <Music />
        <MindesignRadio />
        <AmpedUpLife />
        <MusicLicensing />
        <AfterDarkPortal />
        <FourPillars />
        <NFTGallery />
        <GiveMore />
        <ProudPartners />
        <Contact />
        <NewsletterSignup />
        <Footer />
        <FloatingRadio />
        <SpunFunReturnListener />
        <NowPlayingToast />
      </div>
    </>
  );
};

function App() {
  React.useEffect(() => {
    initAnalytics();
  }, []);

  return (
    <div className="App">
      <RadioProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin" element={<AdminPanel />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </RadioProvider>
    </div>
  );
}

export default App;
